import type { TimelineLayerId } from 'features/mapping/mapping.constants';
import { MapBaseLayerNames } from 'features/mapping/mapping.constants';
import type { MapBaseLayer } from 'features/mapping/mapping.types';
import SatelliteLightningThumb from './images/thumb-satellite-lightning.png';
import SatelliteRadarThumb from './images/thumb-satellite-radar.png';
import SatelliteSmokeThumb from './images/thumb-satellite-smoke.png';
import StreetLightningThumb from './images/thumb-street-lightning.png';
import StreetRadarThumb from './images/thumb-street-radar.png';
import StreetSmokeThumb from './images/thumb-street-smoke.png';
import TerrainLightningThumb from './images/thumb-terrain-lightning.png';
import TerrainRadarThumb from './images/thumb-terrain-radar.png';
import TerrainSmokeThumb from './images/thumb-terrain-smoke.png';

export const TIMELINE_LAYER_THUMBNAILS: Record<
  TimelineLayerId,
  Record<MapBaseLayer, string>
> = {
  radar: {
    [MapBaseLayerNames.STREET]: StreetRadarThumb,
    [MapBaseLayerNames.SATELLITE]: SatelliteRadarThumb,
    [MapBaseLayerNames.TOPOGRAPHIC]: TerrainRadarThumb,
  },
  smoke: {
    [MapBaseLayerNames.STREET]: StreetSmokeThumb,
    [MapBaseLayerNames.SATELLITE]: SatelliteSmokeThumb,
    [MapBaseLayerNames.TOPOGRAPHIC]: TerrainSmokeThumb,
  },
  lightning: {
    [MapBaseLayerNames.STREET]: StreetLightningThumb,
    [MapBaseLayerNames.SATELLITE]: SatelliteLightningThumb,
    [MapBaseLayerNames.TOPOGRAPHIC]: TerrainLightningThumb,
  },
};
